// extracted by mini-css-extract-plugin
export var arrow = "_ch-1";
export var content = "_ch-0";
export var highlighted = "_ch-2";